export class ExcessProtectAddress {
  line1 = '';
  line2 = '';
  line3 = '';
  county = '';
  postcode = '';
}
